exports.components = {
  "component---src-pages-follow-js": () => import("./../../../src/pages/follow.js" /* webpackChunkName: "component---src-pages-follow-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-listen-js": () => import("./../../../src/pages/listen.js" /* webpackChunkName: "component---src-pages-listen-js" */),
  "component---src-templates-lyric-js": () => import("./../../../src/templates/lyric.js" /* webpackChunkName: "component---src-templates-lyric-js" */),
  "component---src-templates-lyrics-js": () => import("./../../../src/templates/lyrics.js" /* webpackChunkName: "component---src-templates-lyrics-js" */)
}

